import React from 'react';

const ClpFlagIcon = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0.5 8C0.5 12.15 3.85 15.5 8 15.5C12.15 15.5 15.5 12.15 15.5 8H0.5Z" fill="#ED4C5C" />
    <path d="M8 0.5C12.15 0.5 15.5 3.85 15.5 8H8V0.5Z" fill="#F9F9F9" />
    <path d="M8 0.5C3.85 0.5 0.5 3.85 0.5 8H8V0.5Z" fill="#2A5F9E" />
    <path d="M5 5.425L6.225 6.25L5.775 4.925L7 4.05H5.475L5 2.75L4.55 4.05H3L4.225 4.925L3.775 6.25L5 5.425Z" fill="#F9F9F9" />
  </svg>
);

export default ClpFlagIcon;
